import { render, staticRenderFns } from "./EditClassAdvisorCombination.vue?vue&type=template&id=716668c8"
import script from "./EditClassAdvisorCombination.vue?vue&type=script&lang=js"
export * from "./EditClassAdvisorCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports